export default __webpack_public_path__ + "static/Graphik-Medium-Cy-Web-81492b497a6035992ca92e01ee804228.woff2";